// src/newDashboard/layout/CharityLayout.jsx
//
// The charity dashboard, grouped into 5 sections like the owner dashboard.
// Same frame (DashboardShell.jsx): side menu on a computer, a bar along
// the bottom on a phone. Every old page address still works.

import React from "react";
import { useActiveBar } from "../ActiveBarContext";
import DashboardShell from "./DashboardShell";
import "../owner/OwnerDashboard.css";

const ADVERTISE_URL = "https://barfunfinder.com/advertise.html";

const icon = (d) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
    {d}
  </svg>
);

const SECTIONS = [
  {
    label: "Overview",
    short: "Home",
    to: "/charity",
    icon: icon(<><path d="M3 11l9-7 9 7" /><path d="M5 10v10h14V10" /></>),
    tabs: [],
  },
  {
    label: "Events",
    short: "Events",
    to: "/charity/events",
    icon: icon(<><rect x="3" y="5" width="18" height="16" rx="2" /><path d="M3 10h18M8 3v4M16 3v4" /></>),
    tabs: [],
  },
  {
    label: "Gaming",
    short: "Gaming",
    to: "/charity/gaming",
    icon: icon(<><rect x="4" y="3" width="16" height="18" rx="2" /><path d="M8 8h8M8 12h8M8 16h5" /></>),
    tabs: [],
  },
  {
    label: "Promote",
    short: "Promote",
    to: "/charity/subscription",
    icon: icon(<><path d="M3 11l14-6v14L3 13z" /><path d="M7 13v5h3" /></>),
    tabs: [
      { label: "Boost & Pro", to: "/charity/subscription" },
      { label: "Notifications", to: "/charity/notifications" },
      { label: "Advertise", href: ADVERTISE_URL },
    ],
  },
  {
    label: "Bars & Account",
    short: "More",
    to: "/charity/linked-bars",
    icon: icon(<><circle cx="12" cy="8" r="4" /><path d="M4 21a8 8 0 0 1 16 0" /></>),
    tabs: [
      { label: "Linked bars", to: "/charity/linked-bars" },
      { label: "Claim a bar", to: "/charity/claim-bar" },
      { label: "Account", to: "/charity/account" },
      { label: "Help", to: "/charity/help" },
    ],
  },
];

export default function CharityLayout({ children }) {
  const { myBars, activeBarId, setActiveBarId } = useActiveBar();

  const barPicker =
    myBars.length > 1 ? (
      <div className="os-bar">
        <label htmlFor="os-bar" className="os-bar-label">Bar</label>
        <select
          id="os-bar"
          className="os-bar-select"
          value={activeBarId}
          onChange={(e) => setActiveBarId(e.target.value)}
        >
          {myBars.map((bar) => (
            <option key={bar.id} value={bar.id}>{bar.name || "Unnamed Bar"}</option>
          ))}
        </select>
      </div>
    ) : null;

  return (
    <DashboardShell sections={SECTIONS} roleLabel="Charity" barPicker={barPicker}>
      {children}
    </DashboardShell>
  );
}
